export default __webpack_public_path__ + "static/media/headerBg.04a7fe88.jpg";